<template>
  <div class="tabItem">
    <div class="aboutSectionTitle aboutSectionTitleC">
      <div class="CNtitle">企业文化</div>
      <div class="ENtitle">ENTERPRISE CULTURE</div>
      <div class="titleLine"></div>
    </div>
    <div class="qywh maxBox">
      <div class="qywhLine">
        <div class="qywhItem qywhItem1"></div>
        <div class="qywhItem qywhItem2">
          <div class="whList">
            <div class="whItem">
              <div class="title">盛世愿景</div>
              <div class="line"></div>
              <div class="text">成为中国最具规模，最具影响力的艺术品投资及资源整合平台。</div>
            </div>
            <div class="whItem">
              <div class="title">盛世使命</div>
              <div class="line"></div>
              <div class="text">弘扬收藏文化，传承中华文明，让收藏走进千家万户。</div>
            </div>
            <div class="whItem">
              <div class="title">盛世愿景</div>
              <div class="line"></div>
              <div class="text">客户：为客户创造价值，让客户对我们的产品满意、服务满意、品牌满意。</div>
              <div class="text">员工：态度决定一切，有目标就有未来。</div>
              <div class="text">事业：为我们共同的事业奋斗终生。</div>
              <div class="text">团队：我们坚信团队至上。</div>
              <div class="text">感恩：以感恩为荣，以忘恩为耻。</div>
            </div>
          </div>
        </div>
      </div>
      <div class="qywhLine">
        <div class="qywhItem qywhItem3">
          <div class="whList">
            <div class="whItem">  
              <div class="title">盛世五大立场</div>
              <div class="line"></div>
              <div class="text">国家立场：永远不做损害国家利益的事，和所有损害国家利益的人划清界限。</div>
              <div class="text">客户立场：永远不做对不起客户的事，和所有损害客户利益的人划清界限。</div>
              <div class="text">公司立场：永远不做损害公司利益的事，和所有损害公司利益的人划清界限。</div>
              <div class="text">领袖立场：永远不做损害领袖名誉的事，和所有损害领袖名誉的人划清界限。</div>
              <div class="text">做大事立场：永远不说一句丧气话，我们将灵魂托付给大事。</div>
            </div>
            <div class="whItem">
              <div class="title">盛世六大核心理念</div>
              <div class="line"></div>
              <div class="text">经营理念：藏天下珍宝，聚八方英才，创千秋伟业。</div>
              <div class="text">销售理念：不被七情六欲所困，销售一切都是为了爱。</div>
              <div class="text">成长理念：今天所受的一切磨难，只为了以后成就更大的伟业。</div>
              <div class="text">做人理念：倾财足以聚人，量宽足以得人，身先足以率人，律己足以服人。</div>
              <div class="text">晋升理念: 创造成果，培养人才，得以晋升。</div>
              <div class="text">学习理念：当下师为无上师，敬畏英雄才能成为英雄。</div>
            </div>
          </div>
        </div>
        <div class="qywhItem qywhItem4"></div>
      </div>
    </div>
    <div class="ygfc maxBox">
      <div class="aboutSectionTitle aboutSectionTitleC">
        <div class="CNtitle">员工风采</div>
        <div class="ENtitle">Staff style</div>
        <div class="titleLine"></div>
      </div>
      <div class="pictureList minBox">
        <div class="listTop">
          <div class="item">
            <img src="~@/assets/img/aboutUs/ygfc1.png" alt="">
            <div class="text">唐恺老师来公司参观指导</div>
          </div>
          <div class="item">
            <img src="~@/assets/img/aboutUs/ygfc2.png" alt="">
            <div class="text">凌浩网络CEO获得优秀企业家称号</div>
          </div>
          <div class="item">
            <img src="~@/assets/img/aboutUs/ygfc3.png" alt="">
            <div class="text">公司集体旅游-舟山群岛</div>
          </div>
        </div>
        <div class="listBot">
          <div class="item">
            <img src="~@/assets/img/aboutUs/ygfc4.png" alt="">
            <div class="text">员工培训</div>
          </div>
          <div class="item">
            <img src="~@/assets/img/aboutUs/ygfc5.png" alt="">
            <div class="text">参观学习</div>
          </div>
          <div class="item">
            <img src="~@/assets/img/aboutUs/ygfc6.png" alt="">
            <div class="text">《瓷韵·凤凰尊》品鉴会</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'tabItem',
  data () {
    return {
    }
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/index.scss';
.tabItem{
  width: 100%;
  background: #fff;
  padding-top: 60px;
  .qywh{
    background: #F4F4F4;
    margin-top: 60px;
    .qywhLine{
      display: flex;
      .qywhItem{
        width: 50%;
        height: 510px;
        min-width: 600px;
        display: flex;
        .whList{
          width: 600px;
          box-sizing: border-box;
          padding-left: 60px;
          overflow: hidden;
          .whItem{
            margin-top: 40px;
            .title{
              font-size: 18px;
              line-height: 18px;
              color: $aboutRed;
            }
            .line{
              width:78px;
              height:2px;
              background:$aboutRed;
              margin-top: 16px;
              margin-bottom: 10px;
            }
            .text{
              font-size: 14px;
              color: #888;
              line-height: 28px;
            }
          }
        }
      }
      .qywhItem1{
        background: url("~@/assets/img/aboutUs/qywh1.png") no-repeat right;
        background-size: cover;
      }
      .qywhItem4{
        background: url("~@/assets/img/aboutUs/qywh2.png") no-repeat left;
        background-size: cover;
      }
      .qywhItem3{
        flex-direction:row-reverse;
      }
    }
  }
  .ygfc{
    padding-top: 60px;
    .pictureList{
      padding: 80px 0 50px;
      .item{
        width: 380px;
        height: 320px;
        position: relative;
        .text{
          width: 100%;
          line-height: 30px;
          text-align: center;
          font-size: 14px;
          color: #fff;
          background:rgba(0,0,0,0.5);
          position: absolute;
          left: 0;
          bottom: 0;
        }
      }
      .listTop,.listBot{
        display: flex;
        justify-content: space-between;
      }
      .listBot{
        margin-top: 85px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/aboutUs/components/tabItem3.vue